



























































































import { Component, Vue } from 'vue-property-decorator';

import authModule from '@/store/Auth';

@Component({})
export default class AlertBanner extends Vue {
  get missingGeccoOrg() {
    return (
      authModule.activeOrganisation &&
      !authModule.activeOrganisation.organisation.geccoOrgId
    );
  }

  get subscriptionExpired() {
    return (
      authModule.activeOrganisation &&
      authModule.activeOrganisation.organisation.subscriptionExpired
    );
  }

  get isOwner() {
    return authModule.isOwner;
  }

  get showSubscriptionButton() {
    return !this.missingGeccoOrg && !this.subscriptionExpired;
  }

  get alertTitle() {
    if (this.missingGeccoOrg) {
      return this.$t('missingGeccoOrg.title');
    }
    if (this.subscriptionExpired) {
      return this.$t('subscriptionExpired.title');
    }
    return this.$t('subscriptionRequired.hiddenContentTitle');
  }

  get renewalLink() {
    if (!authModule.activeOrganisation) {
      throw new Error('Missing active organisation');
    }
    const geccoOrgId = authModule.activeOrganisation.organisation.geccoOrgId || '';
    const portalUrl = this.$t('common.geccoOrgUrl');
    return `${portalUrl}/${geccoOrgId}`;
  }
}
